import modalConstants from '../constants/modals';

export const openModal = ({ modalProps, modalType }) => dispatch => {
  dispatch({
    type: modalConstants.OPEN_MODAL,
    modalProps,
    modalType,
  });
};

export const closeModal = () => dispatch => {
  dispatch({
    type: modalConstants.CLOSE_MODAL,
  });
};

export const resetSuccessRecoveryText = () => dispatch => {
  dispatch({
    type: modalConstants.RESET_SUCCESS_RECOVERY_TEXT,
  });
};